import React, { Component } from 'react';
import { Provider } from 'react-redux'
import intl from 'react-intl-universal'

import { setDefaultConfig, ConfigProvider, Modal } from 'antd-mobile'

import enUS from 'antd-mobile/es/locales/en-US'
import zhCN from 'antd-mobile/es/locales/zh-CN'
import Router from './router'
import store from './store'

import { getCurrLang, getCurLocale, locales } from "./locales";
import { getUrlParam } from './utils'
import { setLanguageStore } from './utils/storage/language'

class App extends Component {
  state = {
    initDone: false,
    lanObj: null,
    tmpKey: null,
    lanKey: null
  }
  componentDidMount() {
    
    const urlLanKey = this.getLangFromUrl()
    const lanKey = urlLanKey || getCurrLang()
    const lanObj = lanKey === 'zh' ? zhCN : enUS
    

    // this.showModalWhenIsNotEnLanguage()

    // const lanKey = 'en'
    // const lanObj = enUS
    // setLanguageStore('en_US')

    setDefaultConfig({ locale: lanObj })
    //this.loadLocales()
    intl.init({
      currentLocale: lanKey,
      locales
    })

    this.setState({ lanKey, lanObj })
  }
  render() {

    // const lanKey = getCurrLang()
    // const lanObj = lanKey === 'zh' ? zhCN : enUS

    // intl.init({
    //   currentLocale: lanKey,
    //   locales
    // })

    const { lanObj } = this.state

    return (
      <ConfigProvider locale={lanObj}>
        <Provider store={store}>
          <Router />
        </Provider>
      </ConfigProvider>

    )
  }
  loadLocales = () => {

    intl.init({
      currentLocale: getCurrLang(),
      locales
    }).then(() => {
      this.setState({ initDone: true })
    })
  }

  getLangFromUrl = () => {
    let lang = getUrlParam('lang')
    if (lang && lang.length > 4) {
      let str = lang.substring(0, 2)
      if (!['zh', 'en', 'th'].includes(str)) {
        lang = 'en_US'
        str = 'en'
      }
      setLanguageStore(lang)
      return str
    }
    return ''
  }

  showModalWhenIsNotEnLanguage = () => {
    let lang = getUrlParam('lang')
    if (lang && lang.length > 4) {
      let str = lang.substring(0, 2)
      if (!['en'].includes(str)) {

        Modal.alert({
          content: 'The travel system currently supports English only. More language options are under development. We apologize for any inconvenience.',
          confirmText: 'OK'
        })
      }

    }
  }



}

export default App;
